__turbopack_context__.v({
  "active": "LanguageSwitcher-module__Ph6iAW__active",
  "btn": "LanguageSwitcher-module__Ph6iAW__btn",
  "container": "LanguageSwitcher-module__Ph6iAW__container",
  "divider": "LanguageSwitcher-module__Ph6iAW__divider",
  "scrolled": "LanguageSwitcher-module__Ph6iAW__scrolled",
});
